// packages block
import { Box, Typography } from '@mui/material'
import { FC } from 'react'
// other block
import { images } from '../../assets/images'
import { EmptyProps } from '../../interfaceTypes'
import { EmptyDataContainer } from '../../theme/styleComponents'

export const EmptyData: FC<EmptyProps> = ({ title, iconSize, fontSize }) => (
  <EmptyDataContainer style={{ height: '400px' }}>
    <Box component="img" src={images.EMPTY} alt="empty" width={iconSize || 'auto'} />

    <Typography variant="body1" fontSize={fontSize || 24} mt="12px">
      {title}
    </Typography>
  </EmptyDataContainer>
)
